/* ==========================================================================
   BELORA - WONDERSKIN MASTER / BEDENIMI BUL

   VERI KAYNAGI (uydurma YOK)
     Model, magazanin KENDI dogrulanmis yorum veri setinden turetildi:
     `assets/belora-reviews.generated.json` icindeki 556 kayitta
     boy(cm) + kilo(kg) + GERCEKTEN SATIN ALINAN beden birlikte bulunuyor.

   MODEL
     duzeltilmis_kilo = kilo - 0.6 x (boy - 165)
     esikler (kg)     : 47 / 57.5 / 65.5 / 75.5 / 82.5 / 91
     bedenler         : XXS XS S M L XL XXL
     ⚠️ (2026-09-04) Shopify beden secenek degerleri harf-only oldu;
     etiketler asagida guncellendi. OLCUM SAYILARI (esikler, katsayi,
     referans boy) DEGISMEDI - yalniz gorunen/karsilastirilan string.

   OLCULEN ISABET
     tum veri            : %93.3 tam beden
     5-kat capraz dogrulama (holdout): %91.2
     +-1 beden           : %100

   NEDEN BOY DA KULLANILIYOR
     Ayni kilo bandinda (64-72 kg) satin alinan beden boya gore ayrisiyor:
     ort. 169.8 cm -> 38-S, 162.8 cm -> 40-M, 154.7 cm -> 42-L.
     Yani boy gercekten ayirt edici; katsayi veriden gelir, tahminden degil.

   ⚠️ BMI KULLANILMAZ. Saglik iddiasi URETILMEZ.
   ⚠️ Musterinin olcusu HICBIR YERE yazilmaz: localStorage, cookie, analitik
      veya ag istegi YOKTUR.
   ⚠️ Gecersiz/aralik disi girdide SONUC URETILMEZ; yuvarlama yapilmaz.
   ========================================================================== */
(function () {
  'use strict';

  var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
  var CUTS = [47, 57.5, 65.5, 75.5, 82.5, 91];
  var HCOEF = 0.6;
  var HREF = 165;

  // Kabul araligi - veri setinin gozlenen sinirlarindan biraz genis, ama
  // fiziksel olarak anlamsiz girdileri reddeder.
  var H_MIN = 140, H_MAX = 200;
  var W_MIN = 35, W_MAX = 160;

  var TEXT = {
    invalid: 'Lutfen gecerli bir boy ve kilo girin.',
    outH: 'Boy 140-200 cm araliginda olmali.',
    outW: 'Kilo 35-160 kg araliginda olmali.',
    near: 'Olcunuz iki beden sinirina cok yakin.'
  };

  /** Saf hesaplama - DOM'dan bagimsiz, QA konsoldan cagirabilir. */
  function recommend(heightCm, weightKg) {
    var h = parseFloat(String(heightCm).replace(',', '.'));
    var w = parseFloat(String(weightKg).replace(',', '.'));
    if (!isFinite(h) || !isFinite(w)) return { ok: false, reason: 'invalid', message: TEXT.invalid };
    if (h < H_MIN || h > H_MAX) return { ok: false, reason: 'height', message: TEXT.outH };
    if (w < W_MIN || w > W_MAX) return { ok: false, reason: 'weight', message: TEXT.outW };

    var v = w - HCOEF * (h - HREF);
    var idx = SIZES.length - 1;
    for (var i = 0; i < CUTS.length; i++) {
      if (v < CUTS[i]) { idx = i; break; }
    }

    // Sinira yakinlik - kesin bir ikinci beden ONERILMEZ, yalniz bilgilendirir.
    var borderline = null;
    var lo = idx > 0 ? CUTS[idx - 1] : null;
    var hi = idx < CUTS.length ? CUTS[idx] : null;
    if (lo !== null && v - lo <= 1.5) borderline = SIZES[idx - 1];
    else if (hi !== null && hi - v <= 1.5) borderline = SIZES[idx + 1];

    return { ok: true, size: SIZES[idx], index: idx, adjusted: Math.round(v * 10) / 10, borderline: borderline };
  }

  /** Belirli bir boy icin bedenin kilo araligi - beden rehberi tablosu bunu kullanir. */
  function rangeFor(index, heightCm) {
    var off = HCOEF * (heightCm - HREF);
    var lo = index > 0 ? Math.round(CUTS[index - 1] + off) : null;
    var hi = index < CUTS.length ? Math.round(CUTS[index] + off) : null;
    return { min: lo, max: hi };
  }

  window.BeloraSizeModel = Object.freeze({
    sizes: SIZES.slice(),
    recommend: recommend,
    rangeFor: rangeFor,
    coefficient: HCOEF,
    reference: HREF,
    thresholds: CUTS.slice()
  });

  /* ------------------------------------------------------------------- UI */
  function init(root) {
    var forms = (root || document).querySelectorAll('[data-ws-sizefinder]');
    Array.prototype.forEach.call(forms, function (box) {
      if (box.__ws) return;
      box.__ws = true;

      var form = box.querySelector('form');
      var hIn = box.querySelector('[data-ws-h]');
      var wIn = box.querySelector('[data-ws-w]');
      var out = box.querySelector('[data-ws-result]');
      var err = box.querySelector('[data-ws-error]');
      if (!form || !hIn || !wIn || !out) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var r = recommend(hIn.value, wIn.value);

        if (!r.ok) {
          out.hidden = true;
          out.innerHTML = '';
          if (err) { err.textContent = r.message; err.hidden = false; }
          return;
        }
        if (err) { err.hidden = true; err.textContent = ''; }

        var rng = rangeFor(r.index, parseFloat(String(hIn.value).replace(',', '.')));
        var rangeText = rng.min === null
          ? rng.max + ' kg ve altina'
          : (rng.max === null ? rng.min + ' kg ve uzerine' : rng.min + '-' + rng.max + ' kg arasina');

        var html =
          '<p class="ws-sf__label">Sana onerdigimiz beden</p>' +
          '<p class="ws-sf__size">' + r.size + '</p>' +
          '<p class="ws-sf__why">Senin boyunda bu beden ' + rangeText +
          ' denk geliyor. Bu oneri, ayni olculerde alisveris yapan gercek musterilerin satin aldigi bedenlerden cikariliyor.</p>';

        if (r.borderline) {
          html += '<p class="ws-sf__note">' + TEXT.near +
            ' Daha sıkı bir tutus istiyorsan kucuk bedeni, daha rahat bir gun boyu kullanim istiyorsan ' +
            r.borderline + ' bedenini secebilirsin.</p>';
        }

        // Gercek beden radio'su varsa "Bu bedeni sec" kontrolu basilir.
        // Yoksa HIC basilmaz - olu bir dugme birakilmaz.
        var radio = findRadio(r.size);
        if (radio) {
          html += '<button type="button" class="ws-btn ws-sf__apply" data-ws-apply="' + r.size.replace(/"/g, '') + '">Bu bedeni sec</button>';
        }

        out.innerHTML = html;
        out.hidden = false;
        out.setAttribute('role', 'status');
      });

      form.addEventListener('reset', function () {
        out.hidden = true;
        out.innerHTML = '';
        if (err) { err.hidden = true; }
      });

      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ws-apply]');
        if (!b) return;
        var radio = findRadio(b.getAttribute('data-ws-apply'));
        if (!radio) return;
        // MUTASYON SAHIPLIGI: sepete istek atilmaz, paralel varyant state
        // tutulmaz. Yalniz GERCEK radio'ya click gonderilir; gerisi temanin
        // variant-picker -> product:rerender zinciridir.
        radio.click();
        if (window.WSCore && window.WSCore.closePanel) window.WSCore.closePanel();
        var chip = document.querySelector('label[for="' + radio.id + '"]');
        if (chip && chip.scrollIntoView) chip.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });
  }

  function findRadio(sizeLabel) {
    var labels = document.querySelectorAll('.ws-opt__values label.ws-opt__chip');
    for (var i = 0; i < labels.length; i++) {
      var full = labels[i].getAttribute('data-value') || labels[i].textContent.trim();
      if (full === sizeLabel) {
        var input = document.getElementById(labels[i].getAttribute('for'));
        if (input && !input.disabled) return input;
        return null;
      }
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
